import MvAnimation from './MvAnimation'
import AutoMovingSlidesVertical from './AutoMovingSlidesVertical'
import AboutSlides from './AboutSlides'
import MemberSlides from './MemberSlides'
import SpecialSlides from './SpecialSlides'

export default class {
  constructor() {

    const domMvAnimation = document.querySelector('[data-js="visual-animation"]');
    if (domMvAnimation) new MvAnimation(domMvAnimation);

    const domAutoMovingSlidesVertical = document.querySelectorAll('[data-js="auto-slide-vertical"]');
    if (domAutoMovingSlidesVertical) {
      [...domAutoMovingSlidesVertical].forEach(el=>{
        new AutoMovingSlidesVertical(el);
      })  
    }  

    const domAboutSlides = document.querySelector('[data-js="about-slide"]');
    if (domAboutSlides) new AboutSlides(domAboutSlides);
    
    const domMemberSlides = document.querySelectorAll('[data-js="member-slide"]');
    if (domMemberSlides) {
      [...domMemberSlides].forEach(el => {
        new MemberSlides(el);
      })
    }
    
    const domSpecialSlides = document.querySelector('[data-js="special-slide"]');
    if (domSpecialSlides) new SpecialSlides(domSpecialSlides);
  }
}
